/* ============================================================================
FILE: po-katupirsia9-chant-d-or-texts-fr-en-es-20260326.js
MODE: protected trilingual with FR / EN / ES buttons + lexicon locking
API:  window.PoKatupirsia9ChantDOrTextsFR_EN_ES_20260326
ROOT: .po-axis-section[data-po-axis='chant_d_or']
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_KATUPIRSIA9_CHANT_D_OR_TEXTS_20260326__) return;
  window.__PO_KATUPIRSIA9_CHANT_D_OR_TEXTS_20260326__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis='chant_d_or']";

  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/chant_d_or_conceptuel.png?v=1773257208";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/chant_d_or_fonctionnel.png?v=1773257209";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "ES";
    if (s.indexOf("en") === 0) return "EN";
    return "FR";
  }

  function getBrowserLang(){
    var dl = document && document.documentElement ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    if (typeof navigator !== "undefined"){
      if (navigator.languages && navigator.languages.length) return normLang(navigator.languages[0] || "fr");
      if (navigator.language) return normLang(navigator.language || "fr");
    }
    return "FR";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      return v ? normLang(v) : "";
    }catch(e){ return ""; }
  }

  function storeLang(lang3){
    try{ localStorage.setItem(STORAGE_KEY, normLang(lang3)); }catch(e){}
  }

  function getLang(){
    return readStoredLang() || getBrowserLang() || "FR";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function nt(txt){
    return '<span class="notranslate" translate="no">' + clampStr(txt) + '</span>';
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) el.innerHTML = clampStr(html);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.setAttribute("src", clampStr(src));
    el.setAttribute("alt", clampStr(alt));
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    (items || []).forEach(function(item){
      var li = document.createElement("li");
      li.textContent = clampStr(item);
      el.appendChild(li);
    });
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    (blocks || []).forEach(function(b){
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.textContent = clampStr((b || {}).head || "");
      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.textContent = clampStr((b || {}).text || "");
      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    });
  }

  function setLockAttrs(root, lang){
    if (!root) return;
    root.classList.add("notranslate");
    root.setAttribute("translate", "no");
    root.setAttribute("lang", normLang(lang).toLowerCase());
    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope){
      scope.classList.add("notranslate");
      scope.setAttribute("translate", "no");
      scope.setAttribute("lang", normLang(lang).toLowerCase());
    }
  }

  var CONTENT = {
    FR: {
      title: "Chant d’Or",
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Langage, son et transmutation ; lecture systémique du " + nt("Souffle d’Or") + ")",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Onde vibratoire du Souffle ; poétique cosmique et expression créatrice du Souffle.",
      def_long: "<p>" + nt("Chant d’Or") + " apparaît, dans <em>Katûpirsia&nbsp;9</em>, au sein des expressions poïétiques et spirituelles. Le manuscrit le formule ainsi : « " + nt("Chant d’Or") + " / " + nt("Voix d’Or") + " — onde vibratoire du Souffle ; poétique cosmique », et lui donne cette fonction : « expression créatrice du Souffle ».</p><p>Dans la lecture systémique intégrée, " + nt("Chant d’Or") + " relève du plan poïétique / créatif, avec " + nt("Modulation dorée") + " et " + nt("Champ d’Or") + ". Sa fonction globale y est formulée de manière nette : le geste créateur comme résonance du " + nt("Souffle d’Or") + ".</p><p>La synthèse finale confirme cette place : « Chant / Voix — expression créatrice (" + nt("Chant d’Or") + ", " + nt("Voix d’Or") + ") ». " + nt("Chant d’Or") + " ne désigne donc pas un ornement verbal ajouté à l’œuvre ; il nomme la forme vibratoire par laquelle le " + nt("Souffle d’Or") + " se fait voix, modulation, geste et rayonnement créateur.</p><p>Le manuscrit pousse enfin cette logique jusqu’à l’ontologie pratique : l’être humain devient « partie du chant d’or que l’univers, depuis toujours, entonne pour se maintenir en existence ». Dans cette perspective, " + nt("Chant d’Or") + " nomme moins une simple émission sonore qu’une mise en résonance créatrice du vivant avec le " + nt("Souffle d’Or") + ".</p>",
      h_features: "Dynamiques opératives",
      h_questions: "Applications / repères",
      hint_fold: "déplier",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      features: [
        "Expression poïétique et spirituelle : le chant d’or appartient au langage, au son et à la transmutation.",
        "Onde vibratoire du Souffle : il se définit comme une poétique cosmique portée par la vibration.",
        "Expression créatrice du Souffle : il est la forme par laquelle le Souffle devient voix, geste et énonciation créatrice.",
        "Plan poïétique / créatif : dans la lecture systémique, il se tient avec Modulation dorée et Champ d’Or.",
        "Résonance du geste créateur : il manifeste la manière dont une création s’accorde au Souffle plutôt qu’à une pure fabrication."
      ],
      questions: [
        "La voix, la forme ou le geste ici observé relèvent-ils d’une simple expression, ou d’une résonance du Souffle ?",
        "Quel passage fait entrer l’œuvre dans une poétique cosmique plutôt que dans une émission isolée ?",
        "Où le champ créatif se met-il à vibrer comme expression du Souffle ?",
        "Quel signe indique que la création devient accord, modulation ou chant plutôt qu’effet ponctuel ?"
      ],
      example_box: "<div><strong>Ex.</strong> Dans une lecture posœnnoïale, lorsqu’une voix, une forme ou un geste cesse d’être simple effet pour devenir résonance du Souffle, l’acte créatif peut être lu comme un chant d’or.</div>",
      family_1: "<p><strong>Liens internes :</strong> " + nt("Chant d’Or") + " appartient au plan poïétique / créatif de la grammaire dorée, avec " + nt("Modulation dorée") + " et " + nt("Champ d’Or") + ". Il entretient un rapport direct avec " + nt("Voix d’Or") + ", dont il partage la formulation canonique.</p>",
      family_2: "<p><strong>Fonction systémique :</strong> dans le manuscrit, " + nt("Chant d’Or") + " désigne l’expression créatrice du " + nt("Souffle d’Or") + ". Il fait passer le souffle vers la voix, la forme et le geste, jusqu’à cette idée ultime : le vivant lui-même participe au chant d’or que l’univers entonne pour se maintenir en existence.</p>",
      word_blocks: [
        { head: "1) Chant", text: "Voix, émission, modulation et tenue vibratoire par lesquelles un souffle devient forme sensible." },
        { head: "2) d’Or", text: "Rapport au Souffle d’Or, à sa clarté opérative et à sa poétique cosmique." },
        { head: "3) Ensemble", text: "L’expression nomme la forme créatrice du Souffle lorsqu’il devient onde, voix, geste et résonance du champ." }
      ],
      word_notes: [
        "Forme canonique conservée en français dans toutes les langues.",
        "Plan principal : poïétique / créatif.",
        "Fonction : expression créatrice du Souffle, geste créateur comme résonance du Souffle."
      ],
      cta_translate: "Proposer une traduction du concept",
      cta_aria: "Proposer une traduction — Lexique simplifié",
      langbar_aria: "Sélecteur de langue"
    },
    EN: {
      title: "Chant d’Or",
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Language, sound and transmutation; systemic reading of the " + nt("Souffle d’Or") + ")",
      h_def: "Operative definition",
      chips: ["Concept ideogram", "Functional ideogram"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Vibratory wave of the Breath; cosmic poetics and creative expression of the Breath.",
      def_long: "<p>" + nt("Chant d’Or") + " appears in <em>Katûpirsia&nbsp;9</em> among the poietic and spiritual expressions. The manuscript formulates it as follows: “" + nt("Chant d’Or") + " / " + nt("Voix d’Or") + " — vibratory wave of the Breath; cosmic poetics,” and assigns it this function: “creative expression of the Breath.”</p><p>In the integrated systemic reading, " + nt("Chant d’Or") + " belongs to the poietic / creative plane, together with " + nt("Modulation dorée") + " and " + nt("Champ d’Or") + ". Its overall function is stated clearly there: the creative gesture as resonance of the " + nt("Souffle d’Or") + ".</p><p>The final synthesis confirms this place: “Chant / Voice — creative expression (" + nt("Chant d’Or") + ", " + nt("Voix d’Or") + ").” " + nt("Chant d’Or") + " therefore does not name a verbal ornament added to the work; it names the vibratory form through which the " + nt("Souffle d’Or") + " becomes voice, modulation, gesture and creative radiance.</p><p>The manuscript finally pushes this logic toward practical ontology: the human being becomes “part of the chant d’or that the universe has always intoned in order to remain in existence.” In this perspective, " + nt("Chant d’Or") + " names less a simple sound emission than a creative resonant attunement of the living with the " + nt("Souffle d’Or") + ".</p>",
      h_features: "Operative dynamics",
      h_questions: "Applications / markers",
      hint_fold: "open",
      h_family: "Systemic links",
      h_wordbuild: "Construction of the term",
      features: [
        "Poietic and spiritual expression: Chant d’Or belongs to language, sound and transmutation.",
        "Vibratory wave of the Breath: it is defined as a cosmic poetics carried by vibration.",
        "Creative expression of the Breath: it is the form through which the Breath becomes voice, gesture and creative utterance.",
        "Poietic / creative plane: in the systemic reading, it stands with Modulation dorée and Champ d’Or.",
        "Resonance of the creative gesture: it manifests the way a creation tunes itself to the Breath rather than to pure fabrication."
      ],
      questions: [
        "Does the voice, form or gesture observed here belong to mere expression, or to a resonance of the Breath?",
        "What passage lets the work enter cosmic poetics rather than an isolated emission?",
        "Where does the creative field begin to vibrate as an expression of the Breath?",
        "What sign indicates that creation becomes attunement, modulation or chant rather than a punctual effect?"
      ],
      example_box: "<div><strong>Ex.</strong> In a posœnnoïal reading, when a voice, form or gesture ceases to be a mere effect and becomes resonance of the Breath, the creative act may be read as a chant d’or.</div>",
      family_1: "<p><strong>Internal links:</strong> " + nt("Chant d’Or") + " belongs to the poietic / creative plane of the golden grammar, together with " + nt("Modulation dorée") + " and " + nt("Champ d’Or") + ". It maintains a direct relation with " + nt("Voix d’Or") + ", with which it shares the canonical formulation.</p>",
      family_2: "<p><strong>Systemic function:</strong> in the manuscript, " + nt("Chant d’Or") + " designates the creative expression of the " + nt("Souffle d’Or") + ". It carries breath toward voice, form and gesture, up to this ultimate idea: living beings themselves participate in the chant d’or that the universe intones in order to maintain itself in existence.</p>",
      word_blocks: [
        { head: "1) Chant", text: "Voice, emission, modulation and vibratory bearing through which a breath becomes a sensible form." },
        { head: "2) d’Or", text: "Relation to Souffle d’Or, to its operative clarity and to its cosmic poetics." },
        { head: "3) Whole", text: "The expression names the creative form of the Breath when it becomes wave, voice, gesture and resonance of the field." }
      ],
      word_notes: [
        "Canonical form kept in French in every language.",
        "Main plane: poietic / creative.",
        "Function: creative expression of the Breath, creative gesture as resonance of the Breath."
      ],
      cta_translate: "Suggest a translation of the concept",
      cta_aria: "Suggest a translation — Simplified lexicon",
      langbar_aria: "Language selector"
    },
    ES: {
      title: "Chant d’Or",
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Lenguaje, sonido y transmutación; lectura sistémica del " + nt("Souffle d’Or") + ")",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Onda vibratoria del Soplo; poética cósmica y expresión creadora del Soplo.",
      def_long: "<p>" + nt("Chant d’Or") + " aparece, en <em>Katûpirsia&nbsp;9</em>, entre las expresiones poiéticas y espirituales. El manuscrito lo formula así: «" + nt("Chant d’Or") + " / " + nt("Voix d’Or") + " — onda vibratoria del Soplo; poética cósmica», y le asigna esta función: «expresión creadora del Soplo».</p><p>En la lectura sistémica integrada, " + nt("Chant d’Or") + " pertenece al plano poiético / creativo, junto con " + nt("Modulation dorée") + " y " + nt("Champ d’Or") + ". Su función global se formula allí con claridad: el gesto creador como resonancia del " + nt("Souffle d’Or") + ".</p><p>La síntesis final confirma este lugar: «Canto / Voz — expresión creadora (" + nt("Chant d’Or") + ", " + nt("Voix d’Or") + ")». Por tanto, " + nt("Chant d’Or") + " no designa un adorno verbal añadido a la obra; nombra la forma vibratoria por la cual el " + nt("Souffle d’Or") + " se vuelve voz, modulación, gesto e irradiación creadora.</p><p>El manuscrito lleva finalmente esta lógica hasta una ontología práctica: el ser humano se vuelve «parte del chant d’or que el universo, desde siempre, entona para mantenerse en existencia». En esta perspectiva, " + nt("Chant d’Or") + " nombra menos una simple emisión sonora que una puesta en resonancia creadora de lo vivo con el " + nt("Souffle d’Or") + ".</p>",
      h_features: "Dinámicas operativas",
      h_questions: "Aplicaciones / referencias",
      hint_fold: "abrir",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      features: [
        "Expresión poiética y espiritual: Chant d’Or pertenece al lenguaje, al sonido y a la transmutación.",
        "Onda vibratoria del Soplo: se define como una poética cósmica sostenida por la vibración.",
        "Expresión creadora del Soplo: es la forma por la cual el Soplo se vuelve voz, gesto y enunciación creadora.",
        "Plano poiético / creativo: en la lectura sistémica, se sitúa junto a Modulation dorée y Champ d’Or.",
        "Resonancia del gesto creador: manifiesta la manera en que una creación se afina con el Soplo más que con una pura fabricación."
      ],
      questions: [
        "¿La voz, la forma o el gesto observados aquí pertenecen a una simple expresión, o a una resonancia del Soplo?",
        "¿Qué paso hace entrar la obra en una poética cósmica más que en una emisión aislada?",
        "¿Dónde el campo creativo empieza a vibrar como expresión del Soplo?",
        "¿Qué signo indica que la creación se vuelve acuerdo, modulación o canto más que efecto puntual?"
      ],
      example_box: "<div><strong>Ej.</strong> En una lectura posœnnoïal, cuando una voz, una forma o un gesto dejan de ser un simple efecto y se vuelven resonancia del Soplo, el acto creador puede leerse como un chant d’or.</div>",
      family_1: "<p><strong>Vínculos internos:</strong> " + nt("Chant d’Or") + " pertenece al plano poiético / creativo de la gramática dorada, junto con " + nt("Modulation dorée") + " y " + nt("Champ d’Or") + ". Mantiene una relación directa con " + nt("Voix d’Or") + ", con la que comparte la formulación canónica.</p>",
      family_2: "<p><strong>Función sistémica:</strong> en el manuscrito, " + nt("Chant d’Or") + " designa la expresión creadora del " + nt("Souffle d’Or") + ". Hace pasar el soplo hacia la voz, la forma y el gesto, hasta esta idea última: el ser vivo participa él mismo en el chant d’or que el universo entona para mantenerse en existencia.</p>",
      word_blocks: [
        { head: "1) Chant", text: "Voz, emisión, modulación y sostén vibratorio por los que un soplo se vuelve forma sensible." },
        { head: "2) d’Or", text: "Relación con Souffle d’Or, con su claridad operativa y con su poética cósmica." },
        { head: "3) Conjunto", text: "La expresión nombra la forma creadora del Soplo cuando se vuelve onda, voz, gesto y resonancia del campo." }
      ],
      word_notes: [
        "Forma canónica conservada en francés en todas las lenguas.",
        "Plano principal: poiético / creativo.",
        "Función: expresión creadora del Soplo, gesto creador como resonancia del Soplo."
      ],
      cta_translate: "Proponer una traducción del concepto",
      cta_aria: "Proponer una traducción — Léxico simplificado",
      langbar_aria: "Selector de idioma"
    }
  };

  /* ==========================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
     Greffe minimale conforme à la marche audio.
  ========================================================================== */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    utter: null,
    activeKey: ""
  };

  var AUDIO_UI = {
    FR: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    EN: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    ES: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.FR;
  }

  function audioLangCode(lang){
    var L = normLang(lang);
    if (L === "EN") return "en-US";
    if (L === "ES") return "es-ES";
    return "fr-FR";
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles-chant-d-or")) return;
    var style = document.createElement("style");
    style.id = "po-axis-audio-styles-chant-d-or";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;justify-content:center;margin:10px 0 12px;}" +
      ".po-axis-audio-btn{appearance:none;border:1px solid rgba(0,0,0,.12);background:rgba(0,0,0,.03);color:inherit;border-radius:999px;padding:8px 14px;font:inherit;font-size:12px;line-height:1;font-weight:700;cursor:pointer;}" +
      ".po-axis-audio-btn:hover{background:rgba(0,0,0,.05);}" +
      ".po-axis-audio-btn.is-playing{border-color:rgba(184,134,11,.55);box-shadow:0 0 0 1px rgba(184,134,11,.18);background:rgba(184,134,11,.08);}" +
      ".po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;}" +
      ".po-lex-summary .po-lex-summary__hint{margin-left:0;}";
    document.head.appendChild(style);
  }

  function stripForAudioText(node){
    if (!node) return "";
    var clone = node.cloneNode(true);
    var trash = clone.querySelectorAll(".po-axis-audio-btn,.po-axis-audio-wrap,script,style");
    Array.prototype.forEach.call(trash, function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    return clampStr(clone.textContent || "").replace(/\s+/g, " ").trim();
  }

  function splitForSpeech(text){
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var parts = src.match(/[^.!?…]+[.!?…]?/g) || [src];
    var out = [];
    var buf = "";
    for (var i = 0; i < parts.length; i++){
      var p = clampStr(parts[i]).trim();
      if (!p) continue;
      if (!buf){
        buf = p;
      } else if ((buf + " " + p).length <= 210){
        buf += " " + p;
      } else {
        out.push(buf);
        buf = p;
      }
    }
    if (buf) out.push(buf);
    return out;
  }

  function stopAudio(resetButtons){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.utter = null;
    PO_AUDIO_STATE.activeKey = "";
    if (resetButtons !== false) refreshAudioButtons();
  }

  function refreshAudioButtons(){
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){
      var lang = getLang();
      var ui = audioUI(lang);
      var btns = root.querySelectorAll(".po-axis-audio-btn");
      Array.prototype.forEach.call(btns, function(btn){
        var role = btn.getAttribute("data-po-audio-role");
        var playing = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === btn.getAttribute("data-po-audio-key"));
        btn.classList.toggle("is-playing", !!playing);
        if (role === "general"){
          btn.textContent = playing ? ui.stop : ui.general;
        } else {
          btn.textContent = playing ? ui.stop : ui.block;
        }
      });
    });
  }

  function createAudioButton(role, key, lang){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-role", role);
    btn.setAttribute("data-po-audio-key", key);
    var ui = audioUI(lang);
    btn.textContent = role === "general" ? ui.general : ui.block;
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();

    var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
    if (!generalWrap){
      generalWrap = document.createElement("div");
      generalWrap.className = "po-axis-audio-wrap";
      generalWrap.setAttribute("data-po-audio-role", "general");
      generalWrap.appendChild(createAudioButton("general", "general", lang));

      var meta = root.querySelector(".po-axis-meta");
      var defShort = root.querySelector("[data-po-slot='def_short']");
      if (meta && meta.parentNode){
        if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
        else meta.parentNode.appendChild(generalWrap);
      } else if (defShort && defShort.parentNode){
        defShort.parentNode.insertBefore(generalWrap, defShort);
      }
    }

    var details = root.querySelectorAll(".po-lex-details");
    Array.prototype.forEach.call(details, function(detail, idx){
      var summary = detail.querySelector(".po-lex-summary");
      if (!summary) return;
      var existing = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='block']");
      if (!existing){
        summary.appendChild(createAudioButton("block", "block-" + idx, lang));
      }
    });

    refreshAudioButtons();
  }

  function collectGeneralText(root){
    var bits = [];
    ["title","kicker","h_def","def_short","def_long"].forEach(function(slot){
      var node = root.querySelector("[data-po-slot='" + slot + "']");
      var txt = stripForAudioText(node);
      if (txt) bits.push(txt);
    });
    return bits.join(" ");
  }

  function collectUnits(root){
    var units = [];
    var general = collectGeneralText(root);
    if (general){
      units.push({
        key: "general",
        kind: "general",
        text: general,
        detailsEl: null
      });
    }

    var details = root.querySelectorAll(".po-lex-details");
    Array.prototype.forEach.call(details, function(detail, idx){
      var summaryTitle = detail.querySelector(".po-lex-summary__title");
      var title = stripForAudioText(summaryTitle);
      var contentClone = detail.cloneNode(true);
      var summary = contentClone.querySelector(".po-lex-summary");
      if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
      var trash = contentClone.querySelectorAll(".po-axis-audio-btn,.po-axis-audio-wrap,script,style");
      Array.prototype.forEach.call(trash, function(el){
        if (el && el.parentNode) el.parentNode.removeChild(el);
      });
      var body = clampStr(contentClone.textContent || "").replace(/\s+/g, " ").trim();
      var merged = (title ? title + ". " : "") + body;
      if (merged.trim()){
        units.push({
          key: "block-" + idx,
          kind: "block",
          text: merged,
          detailsEl: detail
        });
      }
    });
    return units;
  }

  function speakNextChunk(lang){
    if (!PO_AUDIO_SYNTH) return stopAudio();
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      return speakNextUnit(lang);
    }

    var utter = new SpeechSynthesisUtterance(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    utter.lang = audioLangCode(lang);
    utter.onend = function(){ speakNextChunk(lang); };
    utter.onerror = function(){ speakNextChunk(lang); };
    PO_AUDIO_STATE.utter = utter;
    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ speakNextChunk(lang); }
  }

  function speakNextUnit(lang){
    if (!PO_AUDIO_SYNTH) return stopAudio();
    PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      return stopAudio();
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (unit.kind === "block" && unit.detailsEl){
      try{ unit.detailsEl.open = true; }catch(e){}
    }

    PO_AUDIO_STATE.activeKey = unit.key;
    PO_AUDIO_STATE.chunks = splitForSpeech(unit.text);
    PO_AUDIO_STATE.chunkPos = -1;
    refreshAudioButtons();
    speakNextChunk(lang);
  }

  function startAudio(root, startKey){
    if (!PO_AUDIO_SYNTH || !root) return;
    var lang = getLang();
    var units = collectUnits(root);
    if (!units.length) return;

    var startIndex = 0;
    for (var i = 0; i < units.length; i++){
      if (units[i].key === startKey){
        startIndex = i;
        break;
      }
    }

    stopAudio(false);
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units.slice(startIndex);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = startKey;
    refreshAudioButtons();
    speakNextUnit(lang);
  }

  function bindAudioHandlers(root){
    if (!root || root.__po_audio_bound) return;
    root.__po_audio_bound = true;

    root.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest(".po-axis-audio-btn") : null;
      if (!btn || !root.contains(btn)) return;
      ev.preventDefault();
      ev.stopPropagation();

      var key = btn.getAttribute("data-po-audio-key") || "";
      var isSame = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key);

      if (isSame){
        stopAudio();
        return;
      }
      startAudio(root, key);
    }, true);
  }

  function initAudioEverywhere(lang){
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){
      ensureAudioButtons(root, lang);
      bindAudioHandlers(root);
    });
    refreshAudioButtons();
  }

  function updateButtons(root, lang){
    var btns = root.querySelectorAll(".po-langbtn");
    Array.prototype.forEach.call(btns, function(btn){
      var active = normLang(btn.getAttribute("data-po-lang")) === normLang(lang);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.classList.toggle("is-active", active);
    });
    var langbar = root.querySelector(".po-langbar");
    if (langbar) langbar.setAttribute("aria-label", clampStr((CONTENT[lang] || CONTENT.FR).langbar_aria || ""));
    var cta = root.querySelector(".po-axis-breath-link");
    if (cta) cta.setAttribute("aria-label", clampStr((CONTENT[lang] || CONTENT.FR).cta_aria || ""));
  }

  function wireButtons(root){
    if (root.__po_lang_bound) return;
    root.__po_lang_bound = true;
    var btns = root.querySelectorAll(".po-langbtn");
    Array.prototype.forEach.call(btns, function(btn){
      btn.addEventListener("click", function(){
        var lang = normLang(btn.getAttribute("data-po-lang") || "FR");
        applyLangEverywhere(lang);
      });
    });
  }

  function renderRoot(root, lang){
    var T = CONTENT[lang] || CONTENT.FR;
    setLockAttrs(root, lang);
    setSlotText(root, "title", T.title);
    setSlotHTML(root, "kicker", T.kicker);
    setSlotImgSrc(root, "title_img", T.chip_urls[0], T.title);
    setSlotText(root, "h_def", T.h_def);
    setSlotText(root, "chip_1", T.chips[0]);
    setSlotText(root, "chip_2", T.chips[1]);
    setSlotImgSrc(root, "chip_1_img", T.chip_urls[0], T.chips[0]);
    setSlotImgSrc(root, "chip_2_img", T.chip_urls[1], T.chips[1]);
    setSlotText(root, "def_short", T.def_short);
    setSlotHTML(root, "def_long", T.def_long);
    setSlotText(root, "h_features", T.h_features);
    setSlotText(root, "h_questions", T.h_questions);
    setSlotText(root, "hint_fold", T.hint_fold);
    setSlotText(root, "hint_fold2", T.hint_fold);
    setSlotText(root, "h_family", T.h_family);
    setSlotText(root, "hint_fold3", T.hint_fold);
    setSlotText(root, "h_wordbuild", T.h_wordbuild);
    setSlotText(root, "hint_fold4", T.hint_fold);
    renderListInto(root, "features", T.features);
    renderListInto(root, "questions", T.questions);
    setSlotHTML(root, "example_box", T.example_box);
    setSlotHTML(root, "family_1", T.family_1);
    setSlotHTML(root, "family_2", T.family_2);
    renderWordBlocks(root, "wordbuild_blocks", T.word_blocks);
    renderListInto(root, "wordbuild_notes", T.word_notes);
    setSlotText(root, "cta_translate", T.cta_translate);
    updateButtons(root, lang);
    wireButtons(root);
  }

  function applyLangEverywhere(lang3){
    var lang = normLang(lang3);
    storeLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){ renderRoot(root, lang); });
    initAudioEverywhere(lang);
    notifyLocaleChanged();
  }

  function init(){ applyLangEverywhere(getLang()); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  window.PoKatupirsia9ChantDOrTextsFR_EN_ES_20260326 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();